var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('label',{staticClass:"visibleButton",attrs:{"for":"file1"}},[_c('font-awesome-icon',{attrs:{"icon":"upload"}}),_vm._v(" .txtインポート ")],1),_c('input',{ref:"file",attrs:{"type":"file","id":"file1"},on:{"change":_vm.loadFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }